import React from "react";
import { ApplicationEditLayout, Content } from "core/layouts";
import { defaultTemplate } from "core/hoc";
import { BaasicFieldDropdown, BasicInput, BasicCheckbox } from "core/components";
import PropTypes from "prop-types";

const DressingRuleEditTemplate = function ({ dressingRuleEditViewStore }) {
    const {
        form,
        contentLoading,
        frequencyOfCareStore,
        exudateTypeStore,
        thicknessTypeStore,
        applicationTypeStore,
        dressingCategoryStore,
        procedureCodeStore,
        dressingTypeStore,
        toggleBordered,
        isBordered,
        toggleDressingChange,
        isDressingChange,
        pressureStageStore
    } = dressingRuleEditViewStore;
    return (
        <ApplicationEditLayout store={dressingRuleEditViewStore}>
            <Content loading={contentLoading}>
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('procedureCodeId')} store={procedureCodeStore} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--med">
                                    <BasicInput field={form.$('hcpcsShortDescription')} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--med">
                                    <BasicInput field={form.$('hcpcsLongDescription')} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('dressingTypes')} store={dressingTypeStore} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('dressingCategories')} store={dressingCategoryStore} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml u-flex--align-start u-flex--gap--2">
                                    <label className="form__group__label" htmlFor="isBordered">Bordered</label>
                                    <BasicCheckbox id="isBordered" checked={isBordered} onChange={() => toggleBordered()} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('frequenciesOfCare')} store={frequencyOfCareStore} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-7 u-mar--bottom--sml">
                                    <BasicInput field={form.$('medicareQty28Days')} />
                                </div>
                                <div className="form__group col col-lrg-7 u-mar--bottom--sml u-flex--align-start u-flex--gap--2">
                                    <label className="form__group__label" htmlFor="isDressingChange">Qty given is the allowed amount of dressing changes, not billing units</label>
                                    <BasicCheckbox id="isDressingChange" checked={isDressingChange} onChange={() => toggleDressingChange()} />
                                </div>
                                <div className="form__group col col-lrg-7 u-mar--bottom--sml">
                                    <BasicInput field={form.$('maximumAdditionalQty28Days')} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-7 u-mar--bottom--sml">
                                    <BasicInput field={form.$('additionalQtyPerPatient')} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('exudateTypes')} store={exudateTypeStore} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('thicknessTypes')} store={thicknessTypeStore} />
                                </div>
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('pressureStages')} store={pressureStageStore} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                    <BaasicFieldDropdown field={form.$('applicationTypes')} store={applicationTypeStore} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
};

DressingRuleEditTemplate.propTypes = {
    dressingRuleEditViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(DressingRuleEditTemplate);